type Gtag = (...args: unknown[]) => void;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: Gtag;
  }
}

const GTAG_SCRIPT_URL = 'https://www.googletagmanager.com/gtag/js';

let loadedMeasurementId: string | null = null;

function disableFlag(measurementId: string): string {
  return `ga-disable-${measurementId}`;
}

/** Loads gtag.js once. Page views are sent by trackPageView, not automatically. */
export function loadGoogleAnalytics(measurementId: string): void {
  (window as unknown as Record<string, unknown>)[disableFlag(measurementId)] = false;
  if (loadedMeasurementId === measurementId) return;
  loadedMeasurementId = measurementId;

  window.dataLayer = window.dataLayer ?? [];
  // gtag.js reads the `arguments` object itself, not an array copy of it.
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer?.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, {
    // A single-page app: route changes are reported by trackPageView.
    send_page_view: false,
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `${GTAG_SCRIPT_URL}?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);
}

/** Honoured by gtag.js: no further hit is sent for this id. */
export function disableGoogleAnalytics(measurementId: string): void {
  (window as unknown as Record<string, unknown>)[disableFlag(measurementId)] = true;
}

export function trackPageView(measurementId: string, path: string, title: string): void {
  window.gtag?.('event', 'page_view', {
    send_to: measurementId,
    page_path: path,
    page_location: `${window.location.origin}${path}`,
    page_title: title,
  });
}
